import { createConfirmation } from "react-confirm";
import SpoilageGroupDialog from "./SpoilageGroupDialog";

export const showSpoilageGroupDialog = createConfirmation(SpoilageGroupDialog);
